import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(['user', 'bankAccount']),
    getByUser: state => user => {
      return state.objs.filter(ub => ub.user === user);
    },
    getByBankAccount: state => bankAccount => {
      return state.objs.filter(ub => ub.bankAccount === bankAccount);
    }
  },
  mutations: {
    ...functions.createDefaultMutations(['user', 'bankAccount']),
  },
  actions: {
    ...functions.createDefaultActionsWithStore(['user', 'bankAccount'])
  },
}